export interface CoverageRectangle {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export function slantDeltaX(
  slant: number,
  verticalLength: number,
  viewportWidth: number,
  viewportHeight: number,
): number {
  return slant * verticalLength * viewportWidth / viewportHeight;
}

export function slantAngleRadians(
  slant: number,
  viewportWidth: number,
  viewportHeight: number,
): number {
  return Math.atan(slantDeltaX(slant, 1, viewportWidth, viewportHeight));
}

export function centeredCoverageRect(
  coverage: number,
  viewportWidth: number,
  viewportHeight: number,
): CoverageRectangle {
  const width = viewportWidth * coverage;
  const height = viewportHeight * coverage;
  return Object.freeze({
    x: (viewportWidth - width) / 2,
    y: (viewportHeight - height) / 2,
    width,
    height,
  });
}

export function rippleDiameter(radius: number): number {
  return radius * 2;
}
